import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { Tinyflow as TinyflowNative } from './ui';
import './ui/index.css';
import { onMounted, onUnmounted, ref } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'Tinyflow',
  props: {
    className: {},
    style: {},
    data: {},
    provider: {}
  },
  setup(__props, {
    expose: __expose
  }) {
    const props = __props;
    const divRef = ref(null);
    let tinyflow = null;
    // 定义默认的 provider 方法
    const defaultProvider = {
      llm: () => [],
      knowledge: () => [],
      internal: () => []
    };
    onMounted(() => {
      if (divRef.value) {
        // 合并默认 provider 和传入的 props.provider
        const mergedProvider = {
          ...defaultProvider,
          ...props.provider
        };
        tinyflow = new TinyflowNative({
          element: divRef.value,
          data: props.data || {},
          provider: mergedProvider
        });
      }
    });
    onUnmounted(() => {
      if (tinyflow) {
        tinyflow.destroy();
        tinyflow = null;
      }
    });
    const getData = () => {
      if (tinyflow) {
        return tinyflow.getData();
      }
      console.warn('Tinyflow instance is not initialized');
      return null;
    };
    __expose({
      getData
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "divRef",
        ref: divRef,
        class: _normalizeClass(['tinyflow', _ctx.className]),
        style: _normalizeStyle([_ctx.style, {
          "height": "100%"
        }])
      }, null, 6);
    };
  }
});